import { render, staticRenderFns } from "./m-surplus-trim-setting.vue?vue&type=template&id=40ca09af&scoped=true&"
import script from "./m-surplus-trim-setting.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-surplus-trim-setting.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-surplus-trim-setting.vue?vue&type=style&index=0&id=40ca09af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca09af",
  null
  
)

export default component.exports